// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import EstimateBoxSection from 'components/estimate/EstimateBoxSection/EstimateBoxSection';
import EstimateBoxTableContainer from './EstimateBoxTableContainer';

type Props = {
  id: string,
};

class EstimateBoxSections extends Component<Props> {
  render() {
    return (
      <Fragment>
        <EstimateBoxSection name="관리자 견적서 업로드">
          <EstimateBoxTableContainer id={this.props.id} />
        </EstimateBoxSection>
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({}),
  () => ({}),
)(EstimateBoxSections);



// WEBPACK FOOTER //
// ./src/containers/estimate/EstimateBoxSections.js